import Text from '../../components/generic/Text';
import styles from './EmptyState.module.less';
import FallbackImage from '../../components/generic/FallbackImage';

const ErrorState = () => {
  return (
    <FallbackImage src="error-plug" alt="error loading reports">
      <Text.Heading>Something went wrong</Text.Heading>
      <span className={styles.message}>Please try again later.</span>
    </FallbackImage>
  );
};

export default ErrorState;
